import { authSelectors, authTypes } from 'redux/auth';
import history from 'providers/history';

const restartApp = () => {
  history.replace('/');
  window.location.reload();
};

export default store => next => action => {
  if (action.type !== authTypes.getAuthUserSuccess) {
    return next(action);
  }

  const previousWorkspaceId = authSelectors.getWorkspaceId(store.getState());
  const workspaceId = action.payload.workspace?.id;

  const result = next(action);

  if (previousWorkspaceId && workspaceId && previousWorkspaceId !== workspaceId) {
    restartApp();
  }

  return result;
};
